import { render, staticRenderFns } from "./sku-stock-edit.vue?vue&type=template&id=0b961763&"
import script from "./sku-stock-edit.vue?vue&type=script&lang=js&"
export * from "./sku-stock-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports